import produce from 'immer';
import { v4 as uuid } from 'uuid';

import { RefundDocumentsState } from '../types';
import {
	ActionDocumentsTypes,
	SET_DOCUMENTS,
	SET_UPLOADED_FILES,
	DELETE_UPLOADED_FILE,
	SetUploadedFilesPayload,
	DeleteUploadedFilePayload
} from './actions';
import { validateFile } from '@shared/lib/file-upload';

const initialState: RefundDocumentsState = {};

function passengersReducer(state = initialState, { type, payload }: ActionDocumentsTypes) {
	return produce(state, draft => {
		switch (type) {
			case SET_DOCUMENTS: {
				Object.assign(draft, payload);
				break;
			}

			case SET_UPLOADED_FILES: {
				const { passengerId, files } = payload as SetUploadedFilesPayload;

				const prevFiles = draft[passengerId] || [];

				/** добавляем файлам уникальный id и ваилидируем */
				const newFiles = files.map(file => ({
					id: uuid(),
					file,
					error: validateFile(file)
				}));

				draft[passengerId] = [...prevFiles, ...newFiles];

				break;
			}

			case DELETE_UPLOADED_FILE: {
				const { passengerId, fileId } = payload as DeleteUploadedFilePayload;

				const prevFiles = draft[passengerId];

				draft[passengerId] = prevFiles.filter(file => file.id !== fileId);
				break;
			}
		}
	});
}

export default passengersReducer;
